import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DashboardDashletModel} from "./dashboard-dashlet-model";
import {kovanNavigate} from "ui-shared";
import {Router} from "@angular/router";

@Component({
  selector: 'hr-dashlet',
  templateUrl: './dashlet.component.html',
    styleUrls: ['./dashlet.scss'],
})
export class DashletComponent {
    @Input() dashlet: DashboardDashletModel;
    @Output() onClick? = new EventEmitter<any>();
    constructor(private router: Router) {}
    redirect() {
      if(this.dashlet.url){
          let newRelativeUrl = this.router.createUrlTree([this.dashlet.url]);
          let baseUrl = window.location.href.replace(this.router.url, '');
          window.open(baseUrl + newRelativeUrl, '_blank');
      }
      else{
          this.onClick.emit()
      }

    }
}
